export default "__VITE_ASSET__CK27JcPO__"